import config from '../../config';
import { handleErrors } from '../../js/helpers/handleErrors';
import { store } from '../../store';

export function getMonthEvents (
    month: string,
    language: string,
    marts: number[]
) {
    return fetch(config.api.monthEvent/* + '?language=' + language + '&' + marts.map(m => 'mart[]=' + m).join('&') + '&date=' + month*/, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.getState().userStore.token}`
            },
            credentials: 'include',
            body: JSON.stringify({
                language: language,
                mart: marts,
                date: month
            })
        })
            .then(handleErrors)
            .then(res => res.json())
            .then(json => {
                return json

            })
            .catch((error: any) => {
                return []
            })
}

export default getMonthEvents